export default __webpack_public_path__ + "0751e219d7eb10a04c918fa70a46ea68.png";